<div class="admin-content-header d-flex">
  <div class="title">
    <h1 [qcId]="'header-title_h1'" class="header-title">إدارة الأسباب</h1>
  </div>
  <div *ngIf="isHideAddButton" ngbDropdown class="d-flex ml-auto">
    <div>
      <button
        [qcId]="'create-btn'"
        type="button"
        class="d-flex btn Dsbtn-green ml-1 mr-1"
        id="create-btn"
        *ngIf="checkPermission('Pages.Reason.Create')"
        (click)="create()"
      >
        <i class="fa-solid fa-plus"></i>
        <span> إضافة سبب جديد </span>
      </button>
    </div>
  </div>
</div>

<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li [qcId]="'breadcrumb-item1'" class="breadcrumb-item">
      <a>
        <i class="d-inline-block fa-regular fa-house-blank"></i>
        <span> الرئيسية</span>
      </a>
    </li>
    <li [qcId]="'breadcrumb-item2'" class="breadcrumb-item active" aria-current="page">إدارة الأسباب</li>
  </ol>
</nav>

<div class="tabs">
  <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
    <li [ngbNavItem]="1">
      <a ngbNavLink [qcId]="'filter-all'" (click)="this.SetActiveTab(1); changeStatus(true);">الكل </a>
      <ng-template ngbNavContent>
        <app-reason-tab [showStatus]="true" [gridView]="gridView" [searchModel]="searchModel"
          (reloadGrid)="reloadGrid($event)"></app-reason-tab>
      </ng-template>
    </li>
    <li [ngbNavItem]="2">
      <div #navContent></div>
      <a ngbNavLink [qcId]="'filter-suspended'" (click)="this.SetActiveTab(2); changeStatus(true);">أسباب إيقاف القيد</a>
      <ng-template ngbNavContent>
        <app-reason-tab [showStatus]="false" [gridView]="gridView" [searchModel]="searchModel"
          (reloadGrid)="reloadGrid($event)"></app-reason-tab>
      </ng-template>
    </li>
    <li [ngbNavItem]="3">
      <a ngbNavLink [qcId]="'filter-cancelled'" (click)="this.SetActiveTab(3); changeStatus(true);">أسباب إلغاء القيد</a>
      <ng-template ngbNavContent>
        <app-reason-tab [showStatus]="false" [gridView]="gridView" [searchModel]="searchModel"
          (reloadGrid)="reloadGrid($event)"></app-reason-tab>
      </ng-template>
    </li>
  </ul>

  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>




